// Short display name for a game row: "World of Warcraft Classic Anniversary"
// -> "Classic Anniversary", "World of Warcraft Forever" -> "Forever".
// Derived from the DB name so a new game needs no code change.
export function shortGameName(name: string | null | undefined): string {
  if (!name) return "";
  const short = name.replace(/^World of Warcraft:?\s*/i, "").trim();
  return short || name;
}
